module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("acmGc"))).then(() => parcelRequire('ljYL6'));